cv.PublicFundraisersRowEmptyView = Marionette.LayoutView.extend({
  className: 'fundraiser-empty',
  template: cv.Templates['public/fundraisers/fundraisers_row_empty'],

  events : {
  },

  templateHelpers: function(){
    return {
    };
  },

  initialize: function(options){
    console.log('PublicFundraisersRowEmptyView initialized');
  },

  onShow: function(){
  }
});
